<div
  class="connect-panel"
  [class.connect-panel--compact]="compact()"
  [class.connect-panel--connected]="guildConnected()"
>
  <div class="connect-panel__status">
    <span
      class="status-dot"
      [class.status-dot--online]="botHealth().ready"
      [class.status-dot--offline]="!botHealth().ready"
      aria-hidden="true"
    ></span>
    <div class="connect-panel__status-copy">
      <p class="connect-panel__label">
        {{ 'app.patrol.discord.cockpit.connect.botStatus' | translate }}
      </p>
      <div class="connect-panel__value-row">
        <p class="connect-panel__value">
          @if (botHealth().ready) {
            {{
              'app.patrol.discord.cockpit.connect.botOnline'
                | translate: { name: botHealth().loggedInAs }
            }}
          } @else {
            {{ 'app.patrol.discord.cockpit.connect.botOffline' | translate }}
          }
        </p>
        <button
          type="button"
          class="connect-panel__refresh"
          [class.connect-panel__refresh--spinning]="isRefreshing()"
          [disabled]="isRefreshing()"
          [attr.aria-label]="
            'app.patrol.discord.cockpit.connect.refresh' | translate
          "
          (click)="refresh()"
        >
          <img
            src="/public/svgs/refresh.svg"
            alt=""
            width="14"
            height="14"
            aria-hidden="true"
          />
        </button>
      </div>
      @if (botHealth().startupError) {
        <p class="connect-panel__warning">{{ botHealth().startupError }}</p>
      }
    </div>
  </div>

  @if (showInviteActions() && !compact()) {
    <p class="connect-panel__hint">
      @if (displayName()) {
        {{
          'app.patrol.discord.cockpit.connect.inviteHintNamed'
            | translate: { name: displayName() }
        }}
      } @else {
        {{ 'app.patrol.discord.cockpit.connect.inviteHint' | translate }}
      }
    </p>
  }

  @if (showInviteActions() || showFixPermissions()) {
    <div class="connect-panel__actions">
      @if (showInviteActions()) {
        <app-cta-button
          class="connect-panel__btn"
          variant="plain"
          size="small"
          [minHeightDisabled]="true"
          [loading]="isRefreshing()"
          (clicked)="addBot()"
        >
          <span cta-label>{{
            'app.patrol.discord.cockpit.connect.addBot' | translate
          }}</span>
        </app-cta-button>
        <app-cta-button
          class="connect-panel__btn"
          variant="link"
          size="small"
          [minHeightDisabled]="true"
          [loading]="isRefreshing()"
          (clicked)="copyInvite()"
        >
          <span cta-label>
            @if (copiedInvite()) {
              {{ 'app.patrol.discord.cockpit.connect.copied' | translate }}
            } @else {
              {{ 'app.patrol.discord.cockpit.connect.copyInvite' | translate }}
            }
          </span>
        </app-cta-button>
      }

      @if (showFixPermissions()) {
        <app-cta-button
          class="connect-panel__btn"
          variant="plain"
          size="small"
          [minHeightDisabled]="true"
          [loading]="isRefreshing()"
          (clicked)="addBot()"
        >
          <span cta-label>{{
            'app.patrol.discord.cockpit.connect.fixPermissions' | translate
          }}</span>
        </app-cta-button>
      }
    </div>
  }
</div>
